import { graphql } from '@/graphql-setup'

export const SIDEBAR_QUERY = graphql(`
  query Sidebar(
    $filterStartDate: DateTime!
    $workPeriodStartDate: DateTime!
    $filterEndDate: DateTime!
    $user: ID!
    $infringementUser: ID
  ) {
    allIssues(
      closedAt_Isnull: true
      archivedAt_Isnull: true
      relatedInfringement: null
    ) {
      total
    }
    allAbsences(requestStatus: "pending", datetimeStart_Gte: $filterStartDate) {
      total
    }
    allInfringements(
      closedBy_Isnull: true
      archivedAt_Isnull: true
      user: $infringementUser
    ) {
      total
    }
    allWorkPeriods(
      user: $user
      datetimeStart: $workPeriodStartDate
      datetimeEnd: $filterEndDate
    ) {
      total
    }
    allFormTemplates(excludeArchived: true, onlyMenuShortcuts: true) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)
